var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { get, set } from 'lodash';
import { ValidationError } from 'yup';
/**
 * Normalizes a validation error object by reducing its `inner` array of errors into
 * an object literal mapping each error's `path` property to an array of error messages.
 *
 * @param {ValidationError} err - The validation error object to normalize
 * @returns {ValidationErrorReturn} An object literal mapping each error's `path` property to an array of error messages
 */
var normalizeValidationError = function (err) {
    return err.inner.reduce(function (errors, innerError) {
        var path = innerError.path, message = innerError.message;
        // eslint-disable-next-line no-prototype-builtins
        if (path && errors.hasOwnProperty(path)) {
            var prev = get(errors, path);
            prev.push(message);
            set(errors, path, prev);
        }
        else if (path) {
            set(errors, path, [message]);
        }
        return errors;
    }, {});
};
/**
 * Creates a validation function that can be used with React Final Form.
 * The validation function is created based on a Yup schema.
 *
 * @template T - The type of the values to be validated.
 * @param {AnySchema} schema - The Yup schema to use for validation.
 * @returns {ValidationFunction<T>} - A validation function that can be used with React Final Form.
 *{@link ValidationFunction ValidationFunction}
 */
export var createValidator = function (schema) {
    return function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, schema.validate(values, { abortEarly: false })];
                case 1:
                    _a.sent();
                    return [2 /*return*/, {}];
                case 2:
                    err_1 = _a.sent();
                    if (err_1 instanceof ValidationError) {
                        return [2 /*return*/, normalizeValidationError(err_1)];
                    }
                    return [2 /*return*/, {}];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
/**
 * Gets the names of all the form fields in a Yup schema.
 *
 * @template T - The type of the Yup schema.
 * @param {AnySchema<T>} schema - The Yup schema to get the form field names from.
 * @returns {FormNames<T>} - An object containing the names of all the form fields in the schema.
 * {@link FormNames FormNames<T>}
 */
export var getFormFieldNames = function (schema) {
    var fields = schema.fields;
    var names = Object.keys(fields).reduce(function (acc, field) {
        acc[field] = field;
        return acc;
    }, {});
    return names;
};
//# sourceMappingURL=yupHelper.js.map